module.exports = __webpack_public_path__ + "static/media/client_centric.d0f522f9.svg";